Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
//#region src/constant.ts
var FEDERATION_SUPPORTED_TYPES = [
    "script"
];
//#endregion
exports.FEDERATION_SUPPORTED_TYPES = FEDERATION_SUPPORTED_TYPES; //# sourceMappingURL=constant.cjs.map
